import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, switchMap, tap } from 'rxjs/operators';
import { SelectCurrentMemberAndDate } from '~app/addresses/store/member-status/member-status.actions';
import { LoadDeclarationYear } from '~app/company/form/annual-declaration-form/shared/state/annual-declaration.actions';
import { AuthUser } from '~app/core/auth/core/auth-user.model';
import { AuthState } from '~app/core/auth/core/auth.state';
import { SubscriptionState } from '~app/farp-odq/store/subscription';
import { LoadMemberId, LoadSubscriptionPeriods, LoadSubscriptionStatus } from '~app/farp-odq/store/subscription/subscription.actions';
import { LoadYearsInfos } from '~app/inscription/store/year-selection/year-selection.actions';

@Injectable({
  providedIn: 'root',
})
export class HomeTemporaryGuard  {

  memberId$ = this.store.select<string>(SubscriptionState.memberId);

  signedIn$ = this.store.select<boolean>(AuthState.signedIn);

  user$ = this.store.select<AuthUser | null>(AuthState.user);
  
  constructor(
    private store: Store,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.user$.pipe(
      filter(u => !!u),
      tap(u => {
        this.store.dispatch(new LoadMemberId(u!.permitNumber));
      }),
      switchMap(() => this.memberId$),
      filter(memberId => !!memberId),
      tap(memberId => {
        this.store.dispatch(new LoadSubscriptionPeriods(memberId));
        this.store.dispatch(new LoadSubscriptionStatus(memberId));
        this.store.dispatch(new SelectCurrentMemberAndDate(memberId, new Date()));
      }),
      tap((_) => {
        this.store.dispatch(new LoadDeclarationYear());
        this.store.dispatch(new LoadYearsInfos());
      })
    ).subscribe();

     return true;
  }
}
